// extracted by mini-css-extract-plugin
module.exports = {"CustomBadge":"badge_CustomBadge__FMSpP"};